(function ($, Drupal, cookies) {
    'use strict';
    Drupal.behaviors.kafAcctMenu = {
        attach: (context) => {

            $(once('kafAcctMenuBehavior', '.user-nav')).each(function () {
                const firstName = window.sessionStorage.getItem('firstName');
                const zinrelo = JSON.parse(window.sessionStorage.getItem('zinrelo'));
                if (firstName) {
                  Drupal.behaviors.kafAcctMenu.setCustomerName(firstName);
                  Drupal.behaviors.kafAcctMenu.setZinrelo(zinrelo);
                }
                $(document).on('keydown', function(event) {
                    if (event.key == "Escape") {
                        var focused = $(':focus');
                        $(focused).parents('.user-logged-in').children('a').focus();
                        $('.user-logged-in .menu-dropdown .menu').hide();
                    }

                    if (event.key == "Tab") {
                        setTimeout(function() {
                            var focused = $(':focus');
                            if ($(focused).parents('.user__item.user__item-account.menu-item.menu-item--expanded.user-logged-in').length == 0) {
                                $('.user-logged-in .menu-dropdown .menu').hide();
                            }
                        }, 100);
                    }
                });
                cookies.remove('firstName');
                cookies.remove('nameJwt');
            });

        },

        setCustomerName: function(firstName) {
          let $nameElement = $('.user-nav .user__item-first-name');
          let $welcomeElement = $('.account-overview__body--member-name');
          if ($nameElement.length === 0) {
            let $accountButton = $('.user-nav .user__item-account');
            $nameElement = $('<li class="user__item-first-name user__item"/>');
            let $nameLink = $accountButton.children('a').first().clone();
            $nameElement.append($nameLink);
            $accountButton.after($nameElement);
            $nameLink.on('click', function (e) {
              e.preventDefault();
              Drupal.behaviors.kabCustomer.openSlideoutDrawer();
            });
          }
          if (firstName) {
            $nameElement.find('a').text(firstName);
            $welcomeElement.text('Welcome back, ' + firstName + '!');
            window.sessionStorage.setItem('firstName', firstName);
          }
          else {
            window.sessionStorage.removeItem('nameJwt');
            window.sessionStorage.removeItem('firstName');
            $nameElement.remove();
          }
        },

        setZinrelo: function(zinrelo) {
          let $detailsElement = $('.account-overview__body--member-info');
          if (zinrelo) {
            window._zrl = window._zrl || [];
            window._zrl.push( [ 'init' , zinrelo ] );
            window.sessionStorage.setItem('zinrelo', JSON.stringify(zinrelo));
            $detailsElement.html('<span data-zrl-tier></span> member. You currently have <span data-zrl-points=\'available\'></span> points available.');
          }
          else {
            if (window.sessionStorage.getItem('firstName')) {
              $detailsElement.html('You are not yet a member of our Baker\'s Rewards Program. <a href="https://shop.kingarthurbaking.com/rewards-dashboard">Join Now</a>.');
            }
            else {
              $detailsElement.remove();
            }
            window.sessionStorage.removeItem('zinrelo');
          }
        }
    };


})(jQuery, Drupal, window.Cookies);
